import _Promise from "@babel/runtime-corejs2/core-js/promise";
import axios from 'axios';
import { MessageBox } from 'element-ui';
import store from '@/store';
import { getToken, getExpire } from '@/utils/auth';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});
let isRefreshing = false;
let requests = [];
service.interceptors.request.use(config => {
  // do something before request is sent
  if (store.getters.token) {
    config.headers['Authorization'] = getToken(); // Bearer
  }
  if (config.url.indexOf('/refresh_token') >= 0 || config.url.indexOf('/login') >= 0) {
    return config;
  }
  if (store.getters.token && getExpire()) {
    if (getExpire() - new Date().getTime() <= 3600000) {
      // 立即刷新token
      if (!isRefreshing) {
        console.log('刷新token ing');
        isRefreshing = true;
        store.dispatch('user/refreshToken').then(res => {
          isRefreshing = false;
          return res.data.token;
        }).then(response => {
          console.log('刷新token成功，执行队列');
          requests.forEach(cb => cb(response));
          // 执行完成后，清空队列
          requests = [];
        }).catch(res => {
          console.error('refresh token error: ', res);
        });
      }
      const retryOriginalRequest = new _Promise(resolve => {
        requests.push(token => {
          // 因为config中的token是旧的，所以刷新token后要将新token传进来
          config.headers['Authorization'] = 'Bearer ' + token;
          resolve(config);
        });
      });
      return retryOriginalRequest;
    }
  }
  return config;
}, error => {
  return _Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
response => {
  const res = response.data;
  // if the custom code is not 20000, it is judged as an error.
  if (response.status && response.status !== 200) {
    return _Promise.reject(res.message || 'error');
  } else {
    return _Promise.resolve(res);
  }
}, async error => {
  const msgData = error.response.data;
  if (error.response.status === 401 && msgData.error_code === '40301') {
    store.dispatch('user/resetToken');
    window.location.reload();
  } else if (msgData.code !== undefined && msgData.code !== '40301' && error.response.status === 400) {
    MessageBox.alert(msgData.message, '', {
      confirmButtonText: '确定',
      type: 'warning'
    });
  }
  return _Promise.reject(error);
});
export default service;